import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPen,
  faUser,
  faChair,
  faBox
} from "@fortawesome/free-solid-svg-icons";

export default function MoveLocationHeader(props) {

  var {
    origin,
    destination,
    status,
    peopleCount,
    deskCount,
    boxCount,
    onEdit
  } = props;

  function getStatusStyle(status) {
    switch (status) {
      case "Planned":
        return { background: "#e3f2fd", color: "#1565c0" };
      case "Labels Printed":
        return { background: "#ede7f6", color: "#5e35b1" };
      case "In Progress":
        return { background: "#fff8e1", color: "#ef6c00" };
      case "Complete":
        return { background: "#e8f5e9", color: "#2e7d32" };
      default:
        return { background: "#eeeeee", color: "#424242" };
    }
  }

  return (
    <div style={styles.card}>

      {/* LEFT – LOCATION */}
      <div style={styles.left}>

        <FontAwesomeIcon
          icon={faPen}
          title="Edit move location"
          style={styles.edit}
          onClick={onEdit}
        />

        <div>
          <div style={styles.location}>
            {origin}
            <span style={styles.arrow}>→</span>
            {destination}
          </div>
          <div style={styles.subtle}>
            Move Location
          </div>
        </div>

      </div>

      {/* CENTRE – METRICS */}
      <div style={styles.centre}>

        <div style={styles.metric}>
          <FontAwesomeIcon icon={faUser} style={styles.icon} />
          <div style={styles.metricValue}>{peopleCount}</div>
          <div style={styles.metricLabel}>People</div>
        </div>

        <div style={styles.metric}>
          <FontAwesomeIcon icon={faChair} style={styles.icon} />
          <div style={styles.metricValue}>{deskCount}</div>
          <div style={styles.metricLabel}>Desks</div>
        </div>

        <div style={styles.metric}>
          <FontAwesomeIcon icon={faBox} style={styles.icon} />
          <div style={styles.metricValue}>{boxCount}</div>
          <div style={styles.metricLabel}>Boxes</div>
        </div>

      </div>

      {/* RIGHT – STATUS */}
      <div
        style={{
          ...styles.status,
          ...getStatusStyle(status)
        }}
      >
        {status}
      </div>

    </div>
  );
}

const styles = {

  card: {
	position:'sticky',
    flex:1,
    background: "#ffffff",
    padding: "22px 28px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 6px 10px -8px rgba(0,0,0,0.25)",
    borderBottom: "1px solid #e6e6e6",
    marginBottom: "20px"
  },

  left: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },

  edit: {
    cursor: "pointer",
    color: "#2F80ED",
    fontSize: "15px"
  },

  location: {
    fontSize: "18px",
    fontWeight: 600,
    color: "#333"
  },

  arrow: {
    margin: "0 10px",
    color: "#666"
  },

  subtle: {
    fontSize: "12px",
    color: "#888",
    marginTop: "4px"
  },

  centre: {
    display: "flex",
    gap: "36px",
    alignItems: "center"
  },

  metric: {
    textAlign: "center"
  },

  icon: {
    color: "#2F80ED",
    fontSize: "22px"
  },

  metricValue: {
    fontSize: "18px",
    fontWeight: 600,
    marginTop: "4px"
  },

  metricLabel: {
    fontSize: "11px",
    color: "#999"
  },

  status: {
    padding: "6px 14px",
    borderRadius: "14px",
    fontSize: "13px",
    fontWeight: 600,
    whiteSpace: "nowrap"
  }
};
